import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useCallback, useState } from 'react';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import {
  SmallButton,
  SmallLoadingButton,
} from '~components/Order/ordersDispatchStyledComponents';

interface DeactivateConfirmationDialogProps {
  id?: string;
  message: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
}

export default function DeactivateConfirmationDialog({
  id,
  message,
  onClose,
  onConfirm,
  title,
}: DeactivateConfirmationDialogProps) {
  const [isLoading, setIsLoading] = useState(false);

  const isOpen = Boolean(id);

  const handleDeactivate = useCallback(async () => {
    if (!id) {
      return;
    }

    try {
      setIsLoading(true);
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  }, [id, onConfirm]);

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <DialogHeader onClose={onClose}>{title}</DialogHeader>

      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogActions>
        <SmallButton
          color="secondary"
          disabled={isLoading}
          onClick={onClose}
          variant="outlined"
        >
          {t('actions.cancel')}
        </SmallButton>

        <SmallLoadingButton
          color="brandV2Red"
          loading={isLoading}
          onClick={handleDeactivate}
        >
          {t('actions.deactivate')}
        </SmallLoadingButton>
      </DialogActions>
    </Dialog>
  );
}
